A hiring organization corresponding to the given legacy SEEK advertiser ID.

This query accepts browser tokens that include the `query:organizations` or `query:enhanced-job-posting` scope.
